export default "__VITE_ASSET__BDrHzSnx__"